import React, { FC } from "react";
import classnames from "classnames";

import styles from "./grid.module.scss";

type Props = {
  /**
   * A parameter that enables a fixed grid width.
   * For different viewport breakpoints - the width is different
   */
  hasStrictWidth?: boolean;
};

export const Grid: FC<React.PropsWithChildren<Props>> = (props) => {
  const { children, hasStrictWidth = false } = props;

  const className = classnames({
    [styles.root]: true,
    [styles["has-strict-width"]]: hasStrictWidth,
  });

  return <div className={className}>{children}</div>;
};
